import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../App';
import { PreviewModalImage } from '../molecules/PreviewModalImage';
import { Overlay } from '../atoms';

const StyledDiv = styled.div`
  min-width: 296px;
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
  z-index: 1;
  position: relative;
  padding-bottom: env(safe-area-inset-bottom);
`;

export const PreviewModal = observer(() => {
  const root = useRootStore();
  const { isWide } = root.layoutStore;
  const { currentAttachment, isError, isVisibleImage } = root.previewModalStore;

  const onLoad = () => {
    const { showImage, setError } = root!.previewModalStore;
    showImage();
    setError(false);
  };

  const onError = () => {
    const { hideImage, setError } = root!.previewModalStore;
    hideImage();
    setError(true);
  };

  const onClickClose = () => {
    const { hide } = root!.previewModalStore;
    hide();
  };

  return (
    <Overlay onClickClose={onClickClose}>
      <StyledDiv>
        <PreviewModalImage
          attachment={currentAttachment}
          isError={isError}
          isVisibleImage={isVisibleImage}
          isWide={isWide}
          onClickClose={onClickClose}
          onError={onError}
          onLoad={onLoad}
        />
      </StyledDiv>
    </Overlay>
  );
});
